import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ImPhoneHangUp } from "react-icons/im";
import { Avatar, Flex, Space } from "antd";
import { RootState } from "../../../redux/store";
import { useAppDispatch } from "../../../redux/utils/Dispatcher";
import { hangup } from "../../../redux/slices/sipSlice";
import { checkIfContactSaved } from "../../../utils";
import CallControls from "../CallControls";
import "./index.scss";

const HangupIcon = ImPhoneHangUp as unknown as React.FC;

interface MiniCallScreenProps {
  onClick: () => void;
  numberOfCalls: number;
  groupName?: string;
  callTimer?: string;
  currentCall: {
    id: string;
    number?: string;
    info?: string;
    status: string;
    isMuted?: boolean;
    isOnHold?: boolean;
    isGroupCall?: boolean;
    startTime?: number;
  };
}

const MiniCallScreen: React.FC<MiniCallScreenProps> = ({
  onClick,
  groupName,
  callTimer,
  numberOfCalls,
  currentCall,
}) => {
  const dispatch = useAppDispatch();
  // const { calls, currentCallId } = useSelector((state: RootState) => state.sip);
  const { contacts } = useSelector((state: RootState) => state.contacts);
  const [phoneNumber, setPhoneNumber] = useState<string>("");

  useEffect(() => {
    if (!currentCall?.info) return;
    const match = currentCall.info.match(/sip:([^@]+)/);

    if (match) {
      const phoneNumber = match[1];
      setPhoneNumber(phoneNumber);
    } else {
      setPhoneNumber(currentCall?.info);
    }
  }, [currentCall.info]);

  return (
    <div className="mini-call-screen" onClick={onClick}>
      <div className="contact-details">
        <Avatar size={50} />
        <Flex vertical gap={4}>
          <div className="contact-name">
            {currentCall?.isGroupCall
              ? groupName
              : checkIfContactSaved(phoneNumber, contacts)}
          </div>
          <div className="contact-number">
            {currentCall.isGroupCall ? callTimer : phoneNumber}
          </div>
        </Flex>
      </div>

      <CallControls
        currentCall={currentCall}
        isMini={true}
        showDTMF={currentCall.isGroupCall ? false : true}
      />

      <div
        onClick={() => dispatch(hangup(currentCall.id))}
        className="end-call-btn"
      >
        <HangupIcon />
        End
      </div>
    </div>
  );
};

export default React.memo(MiniCallScreen);
